// extracted by mini-css-extract-plugin
module.exports = {"ABDS":"DeltaBasePC_ABDS__imRWD"};